import ubBanzai from 'ub/control/banzai-features';

const callback = () => {
  const params = {
    client_id: ubBanzai.getFeatureValue('googleSsoCredentialKey'),
    discoveryDocs: 'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest',
    ux_mode: 'popup',
    scope: 'profile email openid',
    prompt: 'consent',
  };

  window.gapi.load('auth2', () => {
    window.gapi.auth2.init(params).then(res => { res.disconnect(); });
  });
};

export default () => {
  const element = document.getElementsByTagName('script')[0];
  const fjs = element;
  let js = element;
  js = document.createElement('script');
  js.id = 'google-login';
  js.src = 'https://apis.google.com/js/client:plus.js';
  fjs.parentNode.insertBefore(js, fjs);
  js.onload = callback;
};


// WEBPACK FOOTER //
// ./src/control/google-sso/index.js